import React, { useEffect, useRef, useState } from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import { useDropdown } from 'Hooks/Common';
import { Signer } from 'Interfaces/Document';
import { findOffsetParent } from 'Utils/functions';

import IconArrowCircle from 'Assets/images/icons/arrow-circle.svg';
import IconCancel from 'Assets/images/icons/cancel.svg';
import IconSelectArrow from 'Assets/images/icons/select-arrow-icon.svg';

interface DropDownOption {
  icon: string;
  name: string;
  onClick: () => void;
}

interface DropDownOptionsInterface {
  signers: Signer[];
  anchorClassName: string;
}

const DropDownSigners = ({ signers, anchorClassName }: DropDownOptionsInterface) => {
  const [containerRef, isOpen, open, close] = useDropdown();
  const [isPlaceOnTop, setIsPlaceOnTop] = useState(false);
  const dropdownListRef = useRef(null);
  const toggleDropdown = () => {
    if (isOpen) {
      close();
    } else {
      open();
    }
  };
  useEffect(() => {
    const { anchor, elementsPath } = findOffsetParent(
      containerRef.current,
      offsetParent => !!offsetParent?.classList.contains(anchorClassName),
    );
    const containerHeight = anchor?.clientHeight || 0;
    const { offsetTop } = containerRef.current as HTMLDivElement;
    const offsetsSum = elementsPath.reduce<number>(
      (accum, element) => accum + element.offsetTop,
      0,
    );
    const { clientHeight: dropdownListHeight } =
      dropdownListRef.current || ({} as HTMLDivElement);

    setIsPlaceOnTop(containerHeight < dropdownListHeight + offsetTop + offsetsSum);
  }, [containerRef, isOpen, anchorClassName]);

  return (
    <div className="documents__optionsDropdown" ref={containerRef}>
      <button className="documents__optionsDropdownTrigger" onClick={toggleDropdown}>
        <span
          className={classNames('documents__optionsDropdownTrigger-text', {
            'documents__optionsDropdownTrigger-text--open': isOpen,
          })}
        >
          View
        </span>
        <ReactSVG
          src={IconSelectArrow}
          className={classNames('documents__optionsDropdownTrigger-arrow', {
            'documents__optionsDropdownTrigger-arrow--open': isOpen,
          })}
        />
      </button>
      {isOpen && (
        <div
          className={classNames('documents__dropdownList signers', {
            'documents__dropdownList--top': isPlaceOnTop,
          })}
          ref={dropdownListRef}
        >
          <div className="documents__dropdownOptionWrapper">
            <div className="documents__dropdownOptionSigners documents__dropdownOptionSigners--bold">
              <div className="documents__dropdownOptionSigners--name">Name</div>
              <span>Email</span>
            </div>
          </div>
          {signers.map(signer => (
            <div key={signer.id} className="documents__dropdownOptionWrapper">
              <div className="documents__dropdownOptionSigners">
                <div className="documents__dropdownOptionSigners--name">
                  {signer.name}
                </div>
                <div>{signer.email}</div>

                {signer.isFinished ? (
                  <ReactSVG
                    src={IconArrowCircle}
                    className="documents__dropdownOptionSigners-icon"
                  />
                ) : (
                  ''
                )}
                {signer.isDeclined ? (
                  <ReactSVG
                    src={IconCancel}
                    className="documents__dropdownOptionSigners-declinedIcon"
                  />
                ) : (
                  ''
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropDownSigners;
